import React, { Fragment } from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Radio, Tooltip, Typography } from '@ui';
import { formatString } from '@utils';
import { Col, Row } from 'antd';
import { CampaignTypeCardWrapper } from './styled';

const CampaignTypeCard = ({
    isDisabled,
    tooltip,
    CardIcon,
    label,
    description,
    expanded = false,
    expandedContent,
    ...radioProps
}) => {
    const content = (
        <CampaignTypeCardWrapper
            $isDisabled={isDisabled}
            data-e2e={`campaignwizard_${formatString(label)}-type_card`}
            tabIndex={isDisabled ? 0 : undefined}
            aria-disabled={isDisabled}
        >
            <Radio {...radioProps} disabled={isDisabled} />
            <Row gutter={24} align='middle' wrap={false}>
                <Col>
                    <CardIcon
                        data-e2e={`campaignwizard_${formatString(label)}-type_icon`}
                        color={isDisabled ? COLORS.$gray20Black : COLORS.$gray40Black}
                        width='80px'
                        height='80px'
                    />
                </Col>
                <Col>
                    <Typography.Text
                        data-e2e={`campaignwizard_${formatString(label)}-type_title`}
                        style={BOTTOM_INDENTS.XXS}
                        type='badgeLarge'
                        color={isDisabled ? COLORS.$gray40Black : COLORS.$gray100Black}
                    >
                        {label}
                    </Typography.Text>
                    {description && (
                        <Typography.Text
                            data-e2e={`campaignwizard_${formatString(label)}-type_description`}
                            type='descriptor1'
                            color={isDisabled ? COLORS.$gray40Black : COLORS.$gray100Black}
                        >
                            {description}
                        </Typography.Text>
                    )}
                </Col>
            </Row>
            {expanded && expandedContent}
        </CampaignTypeCardWrapper>
    );
    return isDisabled && tooltip ? (
        <Tooltip
            title={
                <Fragment>
                    <Typography.Title level={3} color={COLORS.$white} style={BOTTOM_INDENTS.S}>
                        {tooltip.title}
                    </Typography.Title>
                    <Typography.Text type='body2' color={COLORS.$white}>
                        {tooltip.text}
                    </Typography.Text>
                </Fragment>
            }
            overlayStyle={{ maxWidth: 300 }}
            trigger={['hover', 'focus']}
        >
            {content}
        </Tooltip>
    ) : (
        content
    );
};

export default CampaignTypeCard;
